"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#F0A000",
  d: "M5.042 10.538c0-.27-.2-.489-.445-.489H3.444c-.245 0-.444.22-.444.489s.2.488.444.488h1.153c.246 0 .445-.219.445-.488Zm.531-5.152a.417.417 0 0 0-.63 0 .522.522 0 0 0 0 .69l.816.895a.42.42 0 0 0 .314.143.424.424 0 0 0 .315-.143.523.523 0 0 0 0-.69l-.815-.895Zm8.757 0a.416.416 0 0 0-.626 0l-.815.895a.52.52 0 0 0 0 .688c.087.095.2.142.313.142a.423.423 0 0 0 .314-.142l.815-.895a.52.52 0 0 0 0-.688ZM9.668 3.254l-.03-.001a.386.386 0 0 0-.06.004l-.03.006a.48.48 0 0 0-.355.478v1.265c0 .258.182.47.414.487l.03.001c.246 0 .445-.219.445-.488V3.74a.483.483 0 0 0-.324-.47l-.032-.008a.404.404 0 0 0-.058-.01ZM7.12 12.333a3.883 3.883 0 0 1 1.15.111c.61-1.674 2.298-2.885 4.295-2.921l.046-.002.045-.001c.194 0 .385.01.573.032-.312-1.601-1.7-2.808-3.366-2.808-1.895 0-3.432 1.563-3.432 3.49 0 .788.257 1.515.69 2.099Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A8ACBD",
  fillRule: "evenodd",
  d: "M8.228 20.747c-1.882 0-3.408-1.597-3.408-3.568 0-1.97 1.526-3.568 3.408-3.568.304 0 .598.046.879.124.574-1.775 2.162-3.058 4.042-3.097l.043-.002.043-.001c2.226 0 4.062 1.749 4.325 4.006.163-.03.33-.048.502-.048 1.623 0 2.938 1.378 2.938 3.077 0 1.7-1.315 3.077-2.938 3.077H8.228Z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=PartlySunnyIcon24.js.map